module.exports = __webpack_public_path__ + "static/img/tag_pop_ups_1.4d6cde0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/tag_pop_ups_1.png
// module id = S2Le
// module chunks = 9